import { compareRows } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function UncutCompare() {
  return (
    <section id="uncut" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="无删减说明"
          title="无删减版和常见版本，到底差在哪"
          desc="如果你在意剧情的完整度，先对照片长与内容差异，再决定用哪个版本，会比看完再回头补更省事。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="hidden grid-cols-3 border-b border-background-200 bg-background-200/60 md:grid">
                <div className="p-4 font-label text-sm font-semibold text-foreground-800">
                  对比维度
                </div>
                <div className="border-l border-background-200 p-4 font-label text-sm font-semibold text-primary-700">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-shield-star-line"></i> 无删减完整版
                  </span>
                </div>
                <div className="border-l border-background-200 p-4 font-label text-sm font-semibold text-foreground-700">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-scissors-cut-line"></i> 常见删减版
                  </span>
                </div>
              </div>

              <div className="divide-y divide-background-200">
                {compareRows.map((row) => (
                  <div key={row.aspect} className="grid grid-cols-1 md:grid-cols-3">
                    <div className="bg-background-100/70 p-4 font-label text-sm font-semibold text-foreground-900 md:bg-transparent">
                      {row.aspect}
                    </div>
                    <div className="flex gap-2 p-4 md:border-l md:border-background-200">
                      <i className="ri-check-line mt-0.5 text-base text-primary-600"></i>
                      <p className="text-sm leading-relaxed text-foreground-700">{row.full}</p>
                    </div>
                    <div className="flex gap-2 bg-background-100/50 p-4 md:border-l md:border-background-200 md:bg-transparent">
                      <i className="ri-subtract-line mt-0.5 text-base text-foreground-500"></i>
                      <p className="text-sm leading-relaxed text-foreground-600">{row.cut}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50 dark:text-foreground-950">
                <i className="ri-lightbulb-flash-line text-xl"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                怎么快速判断完整度
              </h3>
              <ul className="mt-3 space-y-2.5">
                <li className="flex gap-2 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-arrow-right-s-line mt-0.5 text-base text-accent-700"></i>
                  看关键转折段落是否连贯，情绪跳不跳。
                </li>
                <li className="flex gap-2 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-arrow-right-s-line mt-0.5 text-base text-accent-700"></i>
                  留意配角支线有没有中途消失。
                </li>
                <li className="flex gap-2 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-arrow-right-s-line mt-0.5 text-base text-accent-700"></i>
                  对照原著情节，看关键桥段是否被省略。
                </li>
              </ul>
            </div>

            <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-error-warning-line text-xl"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                观看前的两点提醒
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                不同通道的清晰度与可用性会随时间变化，建议同时保留剧集与原著两个入口，遇到衔接不顺时对照补全。
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                本页只做入口整理与说明，不提供资源本身，具体可用情况请以你访问时看到的页面为准。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}